var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service__container"},[_c('div',{staticClass:"service__grid"},_vm._l((_vm.$t('routes.services.paragraphs')),function(paragraph,i){return _c('ServiceParagraph',{key:i,attrs:{"data":paragraph,"has_arrow_down":i === _vm.$t('routes.services.paragraphs').length -1 ? false : true}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }